import { FollowUpPrompt } from '../graphql/schema';
import useStreamingMessageRequest from './useStreamingMessageRequest';

const useCreateMessageWithFollowUpPrompt = (taskId?: string) => {
  const streamingMessageRequest = useStreamingMessageRequest();

  return async (
    followUpPrompt: FollowUpPrompt,
    onReceiveTextChunk: (chunk: string) => void,
    onReceiveToolCall: (name: string) => void,
  ): Promise<void> => {
    if (!taskId) throw new Error('Missing task ID');

    return streamingMessageRequest(
      'createTaskMessageWithFollowUpPrompt',
      taskId,
      followUpPrompt,
      onReceiveTextChunk,
      onReceiveToolCall,
    );
  };
};

export default useCreateMessageWithFollowUpPrompt;
